import {
  Api,
  ApiError,
  FullRequestParams,
  HttpResponse,
} from "./controlPlaneApi";

export let rootMmcApi = new Api();
// api.baseUrl = `/api/obs/${api.baseUrl}`;
const internalRequestFunc = rootMmcApi.request;
rootMmcApi.request = async <T = any, E = any>({
  body,
  secure,
  path,
  type,
  query,
  format,
  baseUrl,
  cancelToken,
  ...params
}: FullRequestParams): Promise<HttpResponse<T, E>> => {
  const internalResp = internalRequestFunc({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params,
  });
  return internalResp.then((e) => CommonAPIValidation(e));
};

export function CommonAPIValidation<D, E>(
  res: HttpResponse<D, E>,
): HttpResponse<D, E> {
  const err = res.error as ApiError;
  if (err && res.status === 403 && err.message === "invalid session") {
    document.location = "/";
  }
  return res;
}
